import TextField from "../../../components/fields/textField/TextField.vue";
import PeriodoField from "../../../components/fields/periodoField/PeriodoField.vue";
import SelectField from "../../../components/fields/selectField/SelectField.vue";
import OkayDialog from "../../../components/dialog/okay/OkayDialog.vue"
import {
  SubstituicaoFeriasService
} from "../../../services/SubstituicaoFeriasService.js";
import {
  AgendarFeriasService
} from "../../../services/AgendarFeriasService.js";
import {
  SolicitarFeriasService
} from "../../../services/SolicitarFeriasService.js";

import PerfilService from "../../../services/PerfilService.js";

import {
  SnackBarModule
} from "../../../modules/SnackBarModule";
import moment from "moment";


export default {
  name: "SubstituicaoServidorFerias",

  components: {
    TextField,
    PeriodoField,
    SelectField,
    OkayDialog
  },


  props: {
    selected: {
      type: Object,
      required: true,
    },
    isOpen: {
      type: Boolean,
      required: true,
    }
  },

  data: () => ({
    form: [{}],
    msg: null,
    OkayDialog: false,
    diasRestantes: 0,
    campos: 1,
    options: [{
      'militares': [],
      'perfil': []
    }],

    loading: {
      field: false,
      btn: false
    }
  }),
  async beforeMount() {
    this.diasRestantes = this.selected.numeroDias
    this.initializeForm();
    await this.pegarPessoasSemFerias();
    this.pegarSubstituicoes();
    this.pegarPerfilMilitar(this.selected.idSigrh);

    this.$forceUpdate();

  },
  watch: {
    isOpen: async function (isOpen) {
      if (isOpen) {
        this.diasRestantes = this.selected.numeroDias
        this.initializeForm();
        await this.pegarPessoasSemFerias();
        this.pegarSubstituicoes();
        this.pegarPerfilMilitar(this.selected.idSigrh);
        this.$forceUpdate();
      }
    },

  },


  methods: {
    initializeForm() {
      this.form = [{
        id: null,
        id_sigrh: null,
        unidadeLotacao: null,
        numeroBm: null,

        dataInicio: this.selected.dataIni,
        dataFim: null,
        numeroDias: null,

        id_perfil: "",
      }];
      this.$forceUpdate();
    },

    async pegarSubstituicoes() {
      const response = await SubstituicaoFeriasService.getSubstituicao(this.selected.idFerias);
      if (response.length) {
        this.campos = response.length

        response.map((el, index) => {

          this.options[index] = {
            militares: this.options[0].militares,
            perfil: this.options[0].perfil
          }


          this.form[index] = {
            id: el.id,
            dataInicio: el.periodo_inicial,
            dataFim: el.periodo_final,
            numeroDias: el.numero_dias,
            id_sigrh: el.id_sigrh,
            id_perfil: el.id_perfil,

          }

          this.selecionarMilitar(index, el.id_sigrh);

        });
      }
      this.$forceUpdate();

    },

    async pegarPessoasSemFerias() {
      const response = await AgendarFeriasService.pegarPessoasSemFerias();

      this.options[0].militares = response.map(el => {
        return {
          text: el.nome,
          value: el.id,
        }
      });
    },

    async pegarPerfilMilitar(id_militar) {
      const response = await PerfilService.getPerfilUserById(id_militar);
      this.options[0].perfil = response.map(el => {
        return {
          text: el.perfil.nome,
          value: el.perfil.id,
        }
      });
      this.$forceUpdate();
    },

    async pegarQuemMilitarEstaSubstituindo(id_militar) {
      const response = await SubstituicaoFeriasService.pegarQuemMilitarEstaSubstituindo(id_militar);
      if (!response.error && response.msg) {
        this.msg = response.msg;
        this.OkayDialog = true;
        this.$forceUpdate();
      }
      return;
    },

    verificarSeTodasDatasIniciasSaoMenoresQueUltimaDataFinal() {
      if (this.campos > 1) {
        this.form.forEach((value) => {

          if (this.form[this.campos - 1].dataInicio <= value.dataIni) {
            return SnackBarModule("A data início deverá ser maior que a data final do último substituto", "error");
          }
        })
      }
      return;
    },

    async calculateDays(index) {
      if (this.form[index].dataInicio) {
        const formData = new FormData();
        formData.append("data_ini", moment(this.form[index].dataInicio).format("YYYY-MM-DD"));
        formData.append("dias", this.form[index].numeroDias);
        const response = await SolicitarFeriasService.calcularDiasUteis(formData);
        this.form[index].dataFim = response.dataFim;
        this.form[index].numeroDias = response.dias_uteis;

        if (index + 1 <= this.campos - 1) {
          let date = new Date(response.dataFim);
          date.setDate(date.getDate() + 2);
          this.form[index + 1].dataInicio = moment(date).format("YYYY-MM-DD")
          this.form[index + 1].dias = this.form[index + 1].dias
        }
        //Update no forms inteiro para pode atualizar os valores
        this.$forceUpdate();
        return this.calcularTotalDiasRestantes();
      }
      return SnackBarModule("Prencha o campo de data inicial", "error");
    },

    async selecionarMilitar(campo, event) {
      if (event != undefined) {
        this.form[campo].id_sigrh = event
        await this.pegarQuemMilitarEstaSubstituindo(event)
      }
    },

    calcularTotalDiasRestantes() {
      let response = true;
      this.diasRestantes = this.selected.numeroDias;
      this.form.forEach((value) => {
        this.diasRestantes = this.diasRestantes - parseInt(value.numeroDias)
        if (this.diasRestantes < 0) {
          SnackBarModule(`Número de dias dos períodos solicitados juntos devem ser menor que ${this.selected.numeroDias}`, "error");
          response = false;

        }
      })
      return response;
    },

    prepareForm() {
      const formData = new FormData();
      let form = true;

      this.form.forEach((element, index) => {


        if (element.dataInicio == null || element.dataFim == null || element.numeroDias == "" || element.id_perfil == "") {
          form = false
          SnackBarModule("Campo(s) obrigatório(s) não informado(s).", "error");
        }

        formData.append(`substituto[${index}][periodo_inicial]`, moment(element.dataInicio).format("YYYY-MM-DD"))
        formData.append(`substituto[${index}][periodo_final]`, moment(element.dataFim).format("YYYY-MM-DD"))
        formData.append(`substituto[${index}][numero_dias]`, element.numeroDias)
        formData.append(`substituto[${index}][id_perfil]`, element.id_perfil)
        formData.append(`substituto[${index}][id_sigrh]`, element.id_sigrh)
        formData.append(`substituto[${index}][unidade_lotacao]`, this.selected.idUnidade)
        formData.append(`substituto[${index}][nome_substituto]`, this.options[0].militares.find(o => o.value == element.id_sigrh).text)

        if (element.numeroBm != null && element.numeroBm != "") {
          formData.append(`substituto[${index}][numeroBm]`, element.numeroBm.replace("-", "").replace(".", ""))
        }
        if (element.id) {
          formData.append(`substituto[${index}][id]`, element.id);

        }
      });

      formData.append(`substituto[id_ferias]`, this.selected.idFerias)


      form = this.calcularTotalDiasRestantes();
      console.log(form);

      if (form) {
        this.saveForm(formData);
        return;
      }

    },

    createNewForm() {
      let date = new Date(this.form[this.campos - 1].dataFim);
      date.setDate(date.getDate() + 2);
      this.campos = this.campos + 1
      this.form[this.campos - 1] = {
        id: null,
        dataInicio: moment(date).format("YYYY-MM-DD"),
        dataFim: null,
        numeroDias: "",
        numeroBm: null,
        id_sigrh: null,
        id_perfil: "",
      }
      this.options[this.campos - 1] = {
        militares: this.options[0].militares,
        perfil: this.options[0].perfil
      }

    },

    numeroBm(campo, event) {
      this.form[campo].numeroBM = event;
      this.$forceUpdate();
    },

    async pegarIdSigrh(campo) {
      const formData = new FormData();
      formData.append(`numeroBm`, this.form[campo].numeroBM.replace("-", "").replace(".", ""))
      const response = await SubstituicaoFeriasService.pegarMilitarPeloNumeroBM(formData);
      this.form[campo].id_sigrh = response;
    },

    removeSubstituto() {
      this.diasLimite = this.diasLimite + parseInt(this.form[this.campos - 1].numeroDias)
      this.form.pop()
      this.campos = this.campos - 1

    },
    async saveForm(formData) {
      this.loading.btn = true;
      const response = await SubstituicaoFeriasService.criarSubstituicaoFerias(formData);
      this.loading.btn = false;
      if (response) {
        this.close();
      }
    },
    close() {
      this.$emit("on-close");
      this.initializeForm();
    },
  }
};